import type { ClassValue } from "clsx"
import clsx from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Teach twMerge our custom font size, or it reads `text-xxs` as a text color
// and drops the real color class (e.g. Button xs losing `text-gray-50`).
const twMerge = extendTailwindMerge({
	extend: { classGroups: { "font-size": [{ text: ["xxs"] }] } },
})

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
